/**
 * #748 — subscribe to the app-wide Polymarket cancel fence.
 *
 * The fence has been correct since #272 but was unobservable: a plain
 * module-scoped Map that React had no way to watch, so a second mount showing
 * the same order kept rendering an ordinary cancel icon while the fence
 * silently refused the click. This is the subscription that was missing.
 *
 * Shaped after Kalshi's equivalent, which every order row already reads as
 * `useAccountStore((s) => s.kalshiCancelStates)`: one hook returning the whole
 * map, consumers index it by order ID. The snapshot holds a stable reference
 * between changes, so an indexing consumer re-renders only when the fence
 * actually moves.
 */
import { useSyncExternalStore } from 'react';
import {
  getPolyCancelSnapshot,
  subscribePolyCancels,
  type PolyCancelStates,
} from '@/lib/trading/bulkOrderCancel';

export function usePolyCancelStates(): PolyCancelStates {
  return useSyncExternalStore(subscribePolyCancels, getPolyCancelSnapshot);
}
